import React, { useState, useEffect } from "react";

import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Divider from "@material-ui/core/Divider";
import Avatar from "@material-ui/core/Avatar";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import AddCommentIcon from "@material-ui/icons/AddComment";
import ModeCommentIcon from "@material-ui/icons/ModeComment";
import router from "next/router";

import { db, fv } from "./utils/firebase";
import withAuth from "./utils/withAuth";
import moment from "moment";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  comments: {
    marginBottom: 20,
  },
  commentEntry: {
    width: "100%",
  },
}));

const CommentFeed = (props) => {
  const classes = useStyles();

  const { upload, auth } = props;

  const [comments, setComments] = useState([]);
  const [comment, setComment] = useState("");

  useEffect(() => {
    let query = db
      .doc(upload)
      .collection("comments")
      .orderBy("created", "desc");

    query.get().then((results) => setComments(results.docs));
  }, [upload]);

  const handleCommentSubmit = async () => {
    const message = comment.trim();

    if (message.length === 0) return;

    const doc = await db.doc(upload).collection("comments").add({
      author: auth.user.email,
      authorName: auth.userData.username,
      message: message,
      created: new Date(),
    });

    const docSnapshot = await doc.get();

    // record the comment
    await db.doc(upload).set(
      {
        meta: { comments: comments.length + 1 },
      },
      { merge: true }
    );

    setComment("");
    setComments([docSnapshot].concat(comments));
  };

  return (
    <List className={classes.comments}>
      <ListItem alignItems="flex-start" key={0}>
        <ListItemAvatar>
          <Avatar
            alt={auth.authenticated ? auth.userData.username : "Anon"}
            src={
              auth.authenticated
                ? `/api/avatar/${auth.userData.username}`
                : "/avatar-blue.png"
            }
          />
        </ListItemAvatar>
        <ListItemText
          primary={
            <TextField
              multiline
              value={comment}
              onFocus={() => {
                if (!auth.authenticated) {
                  router.push("/register");
                }
              }}
              onChange={(e) => {
                setComment(e.target.value);
              }}
              label="Write your comment"
              className={classes.commentEntry}
              InputProps={{
                id: "comment-feed-input",
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Submit comment"
                      onClick={handleCommentSubmit}
                    >
                      {comment.trim().length > 0 ? (
                        <AddCommentIcon />
                      ) : (
                        <ModeCommentIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            ></TextField>
          }
        />
      </ListItem>
      {comments.map((comment, i) => (
        <React.Fragment key={1 + i}>
          <ListItem alignItems="flex-start">
            <ListItemAvatar>
              <Avatar
                alt={comment.get("authorName")}
                src={`/api/avatar/${comment.get("authorName")}`}
              />
            </ListItemAvatar>
            <ListItemText
              primaryTypographyProps={{ style: { whiteSpace: "pre-line" } }}
              primary={comment.get("message")}
              secondary={
                <React.Fragment>
                  <Typography
                    component="span"
                    variant="body2"
                    color="textPrimary"
                  >
                    {comment.get("authorName")}
                  </Typography>
                  {` — ${moment(comment.get("created").toDate()).fromNow()}`}
                </React.Fragment>
              }
            />
          </ListItem>
          <Divider variant="inset" component="li" />
        </React.Fragment>
      ))}
    </List>
  );
};

export default withAuth(CommentFeed);
